import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, ShieldIcon, CrownIcon } from 'lucide-react';
const solutions = [{
  icon: <EyeIcon className="w-8 h-8 text-electric-blue" data-id="element-239" />,
  title: 'Leé en Tiempo Real',
  description: 'Aprendés a detectar microexpresiones, clusters y fugas corporales en segundos. Sin teoría vacía: ejercicios reales desde el Tomo 01.'
}, {
  icon: <ShieldIcon className="w-8 h-8 text-electric-blue" data-id="element-240" />,
  title: 'Protegete de Manipuladores',
  description: 'Identificás banderas rojas gestuales de narcisistas, psicópatas y personas tóxicas antes de que te dañen. Con casos reales por situación.'
}, {
  icon: <CrownIcon className="w-8 h-8 text-electric-blue" data-id="element-241" />,
  title: 'Proyectá Poder y Autoridad',
  description: 'Usás tu propio cuerpo para proyectar presencia, carisma y liderazgo real. Sin actuar, sin falsedad — solo ajustes concretos.'
}];
export function SolutionSection() {
  return <section className="pt-6 pb-6 px-4 bg-[#0A0A0A] relative border-t border-white/5" data-id="element-242">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 pointer-events-none" data-id="element-243"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-5" data-id="element-245">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-246">
            La Solución Definitiva
          </h2>
          <p className="text-base text-smoke/80 max-w-2xl mx-auto" data-id="element-247">
            Un sistema completo de 6 tomos que te entrena para leer, detectar y
            responder — en cualquier situación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-248">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.15
        }} className="bg-deep-black border border-white/10 p-4 rounded-xl flex flex-col items-center text-center hover:border-electric-blue/50 hover:shadow-glow-blue transition-all duration-300 group" data-id="element-249">
              <div className="w-11 h-11 rounded-full bg-electric-blue/10 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform" data-id="element-250">
                {item.icon}
              </div>
              <h3 className="font-heading text-lg font-bold text-white mb-2" data-id="element-251">
                {item.title}
              </h3>
              <p className="text-smoke/80 text-sm leading-relaxed" data-id="element-252">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}